import installationInstructions from './installationInstructions';

const lightCategoryContent = {
  installationInstructions
}

export { lightCategoryContent };
